import { render, staticRenderFns } from "./message-item-his.vue?vue&type=template&id=5cfdd416&scoped=true"
import script from "./message-item-his.vue?vue&type=script&lang=js"
export * from "./message-item-his.vue?vue&type=script&lang=js"
import style0 from "./message-item-his.vue?vue&type=style&index=0&id=5cfdd416&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfdd416",
  null
  
)

export default component.exports